export const blockIconsNavigationCampaign = (
	<span className='material-symbols-outlined'>campaign</span>
);
